// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2reWz","options":"AnswerScale_options__3lGor","selected":"AnswerScale_selected__jagdd"};